module.exports = __webpack_public_path__ + "img/packVideo.0031a6ff.gif";